module.exports = __webpack_public_path__ + "img/4-new.7c3452fd.png";